import { Video } from './video';

export class VideoSection {
    constructor(public id: number, public name: string, public videos: Array<Video>, public displayOrder: number) {}
}
